import firebase from "gatsby-plugin-firebase"

export const currentUser = async () => {
    return await firebase.auth().signInAnonymously();
}

export const getUid = async () => {
    return (await currentUser()).user.uid;
}